
import { FormElems } from '../../components/';
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import 'react-quill/dist/quill.snow.css';
import 'rc-tooltip/assets/bootstrap_white.css';
import deleteImage from '../../static/images/delete.png';
import {
    userInput,
    fieldType,
} from './constants.js';
import './PaymentPageTab.scss';

const suggestedFields = [
    'Mobile Number',
    'Email Address',
    'Address',
    'Date Of Birth',
    'Company Name',
    'Others',
];

const RenderUserDefineFields = ({ fields }) => {
    const [fieldNameErrorMsgs, setFieldNameErrorMsgs] = useState([]);

    const validateFieldName = (val, index) => {
        setFieldNameErrorMsgs(prev => {
            const newErrors = [...prev];
            newErrors[index] = val.length >= 50 ? "Max 50 characters allowed" : "";
            return newErrors;
        });
    };

    const [showSuggestions, setShowSuggestions] = useState(
        Array(fields.length).fill(false)
    );

    const inputRefs = useRef([]);

    const handleSelectSuggestion = (index, suggestion) => {
        const field = fields.get(index);
        fields.remove(index);
        fields.insert(index, {
            ...field,
            name: suggestion === 'Others' ? '' : suggestion,
        });

        setShowSuggestions(prev => {
            const newShowSuggestions = [...prev];
            newShowSuggestions[index] = false;
            return newShowSuggestions;
        });

        setTimeout(() => {
            if (inputRefs.current[index]) {
                inputRefs.current[index].focus();
            }
        }, 0);
    };

    return (
        <div>
            {fields.map((field, index) => (
                <div key={index} className="form-section dynamic-fields">
                    <div
                        className="form-field field-name-container"
                        onMouseEnter={() => {
                            setShowSuggestions(prev => {
                                const newShowSuggestions = [...prev];
                                newShowSuggestions[index] = true;
                                return newShowSuggestions;
                            });
                        }}
                        onMouseLeave={() => {
                            setShowSuggestions(prev => {
                                const newShowSuggestions = [...prev];
                                newShowSuggestions[index] = false;
                                return newShowSuggestions;
                            });
                        }}
                    >
                        <p className="field-name">Field Name</p>
                        <Field
                            name={`${field}.name`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="Enter Name"
                            maxLength={50}
                            inputRef={(el) => (inputRefs.current[index] = el)}
                            onChange={(e) => validateFieldName(e, index)}
                        />
                        {fieldNameErrorMsgs[index] && <span className='errorMsg'>{fieldNameErrorMsgs[index]}</span>} {/* ✅ Show error for specific field */}

                        {showSuggestions[index] && (
                            <ul className="suggestions-list">
                                <h4>Suggested Fields</h4>
                                {suggestedFields.map((suggestion, i) => (
                                    <li
                                        key={i}
                                        onClick={() =>
                                            handleSelectSuggestion(
                                                index,
                                                suggestion
                                            )
                                        }
                                    >
                                        {suggestion}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>

                    <div className="form-field field-name-container">
                        <p className="field-name">Field Type</p>
                        <Field
                            name={`${field}.type`}
                            component={FormElems.Select}
                            placeholder="Field Type"
                            data={fieldType || []}
                            labelField="name"
                            valueField="value"
                            label="Select Field Type"
                        />
                    </div>
                    <div className="form-field field-name-container">
                        <p className="field-name">User Input</p>
                        <Field
                            name={`${field}.validators`}
                            component={FormElems.Select}
                            data={userInput || []}
                            placeholder="User Input"
                            labelField="name"
                            valueField="value"
                            label="Select User Input"
                        />
                    </div>
                    <div className="delete-icon">
                        <button
                            type="button"
                            onClick={() => fields.remove(index)}
                        >
                            <img
                                src={deleteImage}
                                alt="Delete"
                                className="delete-icon"
                            />
                        </button>
                    </div>
                </div>
            ))}

            {fields.length < 7 && (
                <div className="wrapper-container">
                    <p className="add-more" onClick={() => fields.push({})}>
                        + Add More
                    </p>
                </div>
            )}
        </div>
    );
};

RenderUserDefineFields.propTypes = {
    fields: PropTypes.object.isRequired,
};

export default RenderUserDefineFields;